import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import EcoIcon from "../../../components/eco-icon/EcoIcon";
import { fmtDateTime } from "../campanhasApi";
import { listCreativesApi, type CreativeListItem } from "../criativosApi";
import { CreativeImage, ReviewPill } from "./CreativeParts";

type Props = {
  campaignId: string;
  onClose: () => void;
  /** O criativo escolhido (a versão mais recente dele). */
  onPick: (creativeId: string) => void;
};

/** Escolher uma das artes já geradas pela Eco-IA para virar anúncio. As desta campanha vêm primeiro. */
const CreativePickerModal: React.FC<Props> = ({ campaignId, onClose, onPick }) => {
  const [items, setItems] = useState<CreativeListItem[] | null>(null);

  useEffect(() => {
    listCreativesApi()
      .then((list) => setItems([...list].sort((a, b) => Number(b.campaign?.id === campaignId) - Number(a.campaign?.id === campaignId))))
      .catch((e) => {
        toast.error(e?.message);
        setItems([]);
      });
  }, [campaignId]);

  return (
    <div className="ecoDialog__overlay">
      <div className="cmpModal crvPicker" role="dialog" aria-modal="true" aria-labelledby="crv-picker-title">
        <div className="cmpModal__head">
          <h2 id="crv-picker-title" className="cmpModal__title">
            Escolher um criativo da Eco-IA
          </h2>
          <button type="button" className="ecoBtn ecoBtn--icon" aria-label="Fechar" data-modal-close onClick={onClose}>
            <EcoIcon name="x" size={18} />
          </button>
        </div>
        <p className="cmpHint">Clique na arte que vai virar o anúncio. Depois é só escolher os textos.</p>
        {!items ? (
          <p className="cmpLoading">Carregando...</p>
        ) : !items.length ? (
          <p className="ecoEmpty">Nenhum criativo gerado ainda. Use "Gerar criativo desta campanha" na aba Anúncios.</p>
        ) : (
          <ul className="crvGrid crvPicker__grid">
            {items.map((c) => (
              <li key={c.rootId}>
                <button type="button" className="crvCard" onClick={() => onPick(c.id)}>
                  <CreativeImage id={c.id} className={`crvCard__img${c.format === "STORY" ? " crvCard__img--story" : ""}`} alt={`Criativo ${c.title}`} />
                  <span className="crvCard__body">
                    <span className="crvCard__title">{c.title}</span>
                    <span className="cmpSub">
                      v{c.version} · {fmtDateTime(c.updatedAt)}
                    </span>
                    {c.campaign ? <span className="cmpSub">{c.campaign.id === campaignId ? "Desta campanha" : c.campaign.name}</span> : null}
                    <ReviewPill review={c.review} />
                  </span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default CreativePickerModal;
